import { Form, Input, Switch } from 'antd'
import React from 'react'
import { t } from 'i18next'

export default function TeleconsultingCompanyForm ({ form, onFinish, tc }) {
  return (
    <Form
      id="teleconsultingCompanyForm"
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
    >
      <Form.Item name="name" label={t('Admin.TeleconsultingCompanyForm.name')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name="url" label={t('Admin.TeleconsultingCompanyForm.url')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name="increased_slot_duration" label={t('Admin.TeleconsultingCompanyForm.increased_slot_duration')} >
        <Switch onChange={(value) => form.setFieldValue('increased_slot_duration', value)} defaultChecked={tc?.increased_slot_duration} />
      </Form.Item>
    </Form>
  )
}
